import styled from 'styled-components'

interface Props {
    text: string
}

export const StyledTooltip = styled.div<Props>`
    position: relative;

    &:hover {
        ::after {
            visibility: visible;
            opacity: 1;
        }
    }

    &::after {
        visibility: hidden;
        line-height: 20px;
        opacity: 0;
        position: absolute;
        bottom: -90%;
        width: max-content;
        right: 10px;
        content: '${p => p.text}';
        font-size: 14px;
        color: ${p => p.theme.bgColor};
        padding: 2px 6px;
        border-radius: 4px;
        background: #021524;
        opacity: 0;
        transition: 0.2s ease;
        transition-delay: 0.1s;
    }
`
